<template>
  <div style="clear:both;">
    <v-card>
      <v-container fluid>
        <v-row>
          <v-col cols="12" sm="10">
            <v-textarea
              :label="$t('Sent_Back_Reason')"
              name="reason"
              :model-value="sentBackReasonText"
              auto-grow
              variant="underlined"
              readonly
              dense
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <people-picker :label="$t('Sent_Back_By')" readonly :user="sentBackUser" :inUser="sentBackUser"></people-picker>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field :model-value="$filters.DateTimeFilter(sentBackDateValue)" readonly dense variant="underlined" density="comfortable"></v-text-field>
          </v-col>
        </v-row>

        <template v-if="sentBackHistoryLog.length > 0">
          <v-row>
            <v-col cols="12">{{ 'History' }}</v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-data-table
                :headers="headers"
                :items="sentBackHistoryLog"
                class="elevation-1"
                :footer-props="pagination"
                :options.sync="options"
                :sort-by="options.sortBy"
                :sort-desc="options.descending"
              >
                <template v-slot:item="props">
                  <tr>
                    <td>
                      <v-textarea auto-grow variant="underlined" readonly :rows="1" :value="props.item.reason"></v-textarea>
                    </td>
                    <td>{{ sentBackUserDisplayName(props.item.sentBackBy) }}</td>
                    <td>{{ $filters.DateTimeFilter(props.item.sentBackDate) }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </template>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import PeoplePicker from '@/components/peoplePicker/PeoplePicker'
export default {
  data() {
    return {
      pagination: {
        'items-per-page-options': [10, 20, 30, 40]
      },
      options: {
        itemsPerPage: 20,
        sortBy: ['sentBackDate'],
        descending: true
      },
      headers: [
        {
          title: this.$t('Sent_Back_Reason'),
          align: 'left',
          key: 'reason'
        },
        { title: this.$t('Sent_Back_By'), key: 'sentBackBy' },
        { title: this.$t('Sent_Back_Date'), key: 'sentBackate' }
      ]
    }
  },
  props: {
    sentBackReason: {
      type: Object,
      default: null
    },
    roles: {
      type: Array,
      default: null
    },
    mocFormStatus: {
      type: String
    },
    sentBackHistory: {
      type: Array,
      default: null
    }
  },
  components: {
    PeoplePicker
  },
  methods: {
    sentBackUserDisplayName: function(user) {
      return user ? user.displayName : ''
    }
  },
  computed: {
    sentBackUser: function() {
      if (this.sentBackReason) {
        if (this.sentBackReason.sentBackBy) {
          return this.sentBackReason.sentBackBy
        }
      }
      return null
    },
    sentBackReasonText: function() {
      if (this.sentBackReason) {
        return this.sentBackReason.reason
      } else {
        return ''
      }
    },
    sentBackDateValue: function() {
      if (this.sentBackReason) {
        return this.sentBackReason.sentBackDate
      } else {
        return null
      }
    },
    sentBackHistoryLog: function() {
      if (this.sentBackHistory) {
        if (this.sentBackHistory.length > 1) {
          return this.sentBackHistory.slice(0, this.sentBackHistory.length - 1)
        }
      }
      return []
    }
  }
}
</script>

<style scoped></style>
